/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(2451) FIXME: Cannot redeclare block-scoped variable 'CustomSect... Remove this comment to see the full error message
const CustomSections = (customSections, feed, bxService, $sce) => ({
   replace: true,
   templateUrl: '/assets/customSections.html',

   link(scope: any, el: any) {
      scope.sections = customSections.scope
      scope.displaySections = () => {
         return scope.sections.sections.length && !bxService.showRecommendations
      }
 
      scope.displayMoreButton = () => {
         return scope.sections.showMoreOptionally && (scope.sections.limit < scope.sections.sections.length)
      }
      scope.displayLessButton = () => {
         return scope.sections.showMoreOptionally && (scope.sections.limit > scope.sections.minLimit) && (scope.sections.limit === scope.sections.sections.length)
      }
      return scope.trustAsHtml = $sce.trustAsHtml
   }
})

angular.module('summonApp.directives')
   .directive('customSections', ['customSectionsService', 'resultsFeedService', 'bxRecommenderService', '$sce', CustomSections])
